import React from 'react'


export default (props) => (
	<div className='capps-logo' onTouchTap={() => {
		window.localStorage.setItem('MoonSignApp:welcome', true)
		props.redux.nav.setPage('')
	}} />
)



// WEBPACK FOOTER //
// ./src/Components/Display/Logo.js